import React, { useEffect } from 'react'
import IFMS from './Components/IFMS';

export default function IFMS_Home() {
    useEffect(
        ()=>{
            document.title="Integrated Facility Management Services"
        },[]
    );
  return (
    <div>
      {/* <h2>Integrated Facility Management Services Home Page</h2> */}
    <IFMS/>
    </div>
  )
}
